export default function HeroSection() {
  return (
    <section className="relative w-full h-[72vh] min-h-[560px] overflow-hidden">
      <img
        src="https://public.readdy.ai/ai/img_res/1fdadb7382bb1881ac48c7b0b272ca04.jpg"
        alt="Pet-friendly cabin in Highlands North Carolina surrounded by mountain forest"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/55" />
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-6 pt-20">
        <p className="text-[#C9A96E] text-xs tracking-[0.35em] uppercase font-jost mb-4">/ Highlands NC Cabin Guide</p>
        <h1 className="font-cormorant text-6xl md:text-7xl text-white font-light leading-none mb-5">
          Pet Friendly Cabins<br /><em className="italic">Highlands NC</em>
        </h1>
        <p className="text-white/75 font-jost text-base leading-relaxed max-w-2xl">
          A curated guide to pet-friendly cabin stays in Highlands, North Carolina — close to trails, waterfalls, and the natural beauty of the Blue Ridge Mountains.
        </p>
      </div>
    </section>
  );
}
